export default "__VITE_ASSET__BGsTvHAp__"